var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.wrapper, _vm.wrapperMode && _vm.$style.wrapperMode]},[_c('l-slider',{attrs:{"items":_vm.comics},on:{"finish":function($event){return _vm.$emit('click', 1)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }